module.exports = __webpack_public_path__ + "img/icon-info-2.7c296e94.svg";